import useThriveAuth from 'hooks/useThriveAuth'
import classNames from 'classnames'
import styles from './index.module.scss'
import { useState } from 'react'
import { useSpring, animated } from 'react-spring'
import { config } from '@react-spring/web'

type LoginProfileIconProps = {
  isToggleOpen?: boolean
}

const LoginProfileIcon: React.FC<LoginProfileIconProps> = ({
  isToggleOpen = false,
}) => {
  const { user } = useThriveAuth()
  const loggedInProfileInitial = (user?.firstName ||
    user?.email)?.[0]?.toUpperCase()

  const [profileHovered, setProfileHovered] = useState<boolean>(false)
  const isProfileActive = profileHovered || isToggleOpen

  const scaleAnimationStyles = useSpring({
    transform: isProfileActive ? 'scale(1)' : 'scale(0)',
    config: config.stiff,
  })
  const borderAnimationStyles = useSpring({
    borderWidth: isProfileActive ? 3 : 0,
    config: config.stiff,
  })

  return (
    <animated.div
      className={classNames(styles.profile_btn, 'flex-center ml-2 fs-20')}
      style={borderAnimationStyles}
      onMouseEnter={() => setProfileHovered(true)}
      onMouseLeave={() => setProfileHovered(false)}
    >
      <animated.div
        className={styles.animated_background}
        style={scaleAnimationStyles}
      />
      <span className={styles.profile_letter}>{loggedInProfileInitial}</span>
    </animated.div>
  )
}

export default LoginProfileIcon
